'use client';
import React, { useEffect } from 'react';

import dynamic from 'next/dynamic';

const LottiePlayer = dynamic(() =>
  import('@lottiefiles/react-lottie-player').then((mod) => mod.Player)
);

import { useSkipEffectOnMount } from '@hooks/lifecycle';
import { useDevice } from '@contexts/device';
import {
  getSafeLocalStorageItem,
  removeSafeLocalStorageItem,
} from '@utils/localStorage/getSafeLocalStorage';

import { Container, Wrapper, Text, SubText } from './LoaderStyle';

export interface LoaderProps {
  text?: string;
  subText?: string;
  loaderType: {}; // we have three type of animation such as listing,payment and general.
  redirect?: () => void;
  shouldScroll?: boolean;
}

const isLoggingOut = () => getSafeLocalStorageItem('loginAction') === 'out';

const completeLoggingOut = () => removeSafeLocalStorageItem('loginAction');

const Loader = ({
  text,
  subText,
  loaderType,
  redirect,
  shouldScroll,
}: LoaderProps) => {
  useEffect(() => {
    if (shouldScroll) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    document.body.style.overflowY = 'hidden';

    return () => {
      document.body.style.overflowY = 'initial';
    };
  }, []);

  useSkipEffectOnMount(() => {
    if (isLoggingOut()) {
      completeLoggingOut();
      return;
    }
    redirect?.();
  }, [redirect]);
  const { isDesktop } = useDevice();
  return (
    <Container>
      {text || subText ? (
        <Wrapper>
          {text ? <Text fontSize={isDesktop ? 45 : 35}>{text}</Text> : null}
          {subText ? (
            <SubText fontSize={isDesktop ? 30 : 20}>{subText}</SubText>
          ) : null}
        </Wrapper>
      ) : null}
      <LottiePlayer
        style={{ height: 150 }}
        autoplay
        loop={true}
        src={loaderType}
      />
    </Container>
  );
};

export default Loader;
